var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "55px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#0f0f0f;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#0f0f0f;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#0f0f0f;stroke-width:1.2;stroke-miterlimit:10;}\n\t.st5{fill:#0f0f0f;stroke:#0f0f0f;stroke-miterlimit:10;}\n\t.st6{font-family:'Calibri-Light';}\n\t.st7{font-size:18.1395px;}\n\t.st8{fill:none;stroke:#0f0f0f;stroke-width:1.5242;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#0f0f0f;stroke-width:1.3615;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#0f0f0f;stroke-width:1.8154;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#0f0f0f;}\n\t.st12{fill:none;stroke:#0f0f0f;stroke-width:1.7;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#0f0f0f;stroke-width:1.8031;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#0f0f0f;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#0f0f0f;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:none;}\n\t.st17{fill:none;stroke:#0f0f0f;stroke-width:1.754;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#0f0f0f;stroke-width:1.7;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#0f0f0f;stroke-width:1.2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#F7931E;stroke-width:1.2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#0f0f0f;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st22{display:inline;fill:none;stroke:#0f0f0f;stroke-width:1.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_10",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st1",
    width: 75,
    height: 75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_1",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "parking",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 48.63,
    y1: 65.56,
    x2: 26.75,
    y2: 65.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.65,65.14l-2.56-1.22c-0.08-0.04-0.16-0.08-0.24-0.13l-3.01-1.8c-0.84-0.5-1.35-1.41-1.35-2.39V51.4 c0-0.78,0.32-1.52,0.89-2.04l1.37-1.27c0.8-0.74,1.09-1.89,0.75-2.92l-1.9-2.11c-0.11-0.32,0.13-0.65,0.47-0.65l6.67-0.89 c0.15-0.01,0.3-0.02,0.44-0.04c10.42-1.69,20.07-2.4,26.61,0.85c0.32,0.06,11.81,7.36,11.81,7.36c0.78,0.5,1.69,0.78,2.62,0.81 l5.6,0.14c2.09,0.05,4.14,0.74,5.72,2.1c0.7,0.61,1.31,1.31,1.75,2.07c0.5,0.85,0.7,1.84,0.7,2.83c0,1.21,0,3.39,0,5.16 c0,1.54-1.25,2.78-2.78,2.78h-1.69h-1.79"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 19.8,
    cy: 63.86,
    r: 7.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 55.58,
    cy: 63.86,
    r: 7.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "54.69,50.44 19.02,50.44 15.33,45.97  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32.2,
    y1: 50.44,
    x2: 28.06,
    y2: 40.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 52.01,
    cy: 22.72,
    r: 10.73
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 47.8105 28.5298)",
    className: "st5 st6 st7"
  }, "P"), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.06,40.61L37.2,28.2c-2.2-6.02-0.53-12.77,4.22-17.07l0,0c6.15-5.56,15.56-5.4,21.51,0.37l0.39,0.38 c4.87,4.73,6.17,12.04,3.21,18.15L56.48,47.76"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.7,70.5H15.3c-0.44,0-0.8-0.36-0.8-0.8V14.3c0-0.44,0.36-0.8,0.8-0.8H60.7c0.44,0,0.8,0.36,0.8,0.8V69.7 C61.5,70.14,61.14,70.5,60.7,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.1,44.5H24.9c-1.32,0-2.4-1.07-2.4-2.4V22.9c0-1.32,1.07-2.4,2.4-2.4h27.2c1.32,0,2.4,1.07,2.4,2.4v19.2 C54.5,43.43,53.43,44.5,52.1,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.71,54.5h-4.42c-0.44,0-0.79-0.35-0.79-0.79v-4.42c0-0.44,0.35-0.79,0.79-0.79h4.42 c0.44,0,0.79,0.35,0.79,0.79v4.42C27.5,54.15,27.15,54.5,26.71,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.71,65.5h-4.42c-0.44,0-0.79-0.35-0.79-0.79v-4.42c0-0.44,0.35-0.79,0.79-0.79h4.42 c0.44,0,0.79,0.35,0.79,0.79v4.42C27.5,65.15,27.15,65.5,26.71,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.3,13.5l40.13-9.74c0.54-0.13,1.06,0.28,1.06,0.84v8.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49,38.5H29c-0.83,0-1.5-0.67-1.5-1.5l0,0c0-0.83,0.67-1.5,1.5-1.5h20c0.83,0,1.5,0.67,1.5,1.5l0,0 C50.5,37.83,49.83,38.5,49,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.12,35.5H31.5v-1.11c0-3.81,3.09-6.89,6.89-6.89h0.84c3.81,0,6.89,3.09,6.89,6.89V35.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 39,
    cy: 26,
    r: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 54.5,
    y1: 48.5,
    x2: 39.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 54.5,
    y1: 54.5,
    x2: 33,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 54.5,
    y1: 59.5,
    x2: 39.5,
    y2: 59.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 54.5,
    y1: 64.5,
    x2: 33,
    y2: 64.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "wifi"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.1,68.37H10.9c-2.71,0-4.9-2.19-4.9-4.9V49.9c0-2.71,2.19-4.9,4.9-4.9h53.2c2.71,0,4.9,2.19,4.9,4.9v13.57 C69,66.18,66.81,68.37,64.1,68.37z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 37.42,
    cy: 35.82,
    r: 3.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M22.45,23.57c6.97-9.71,23.47-9.12,29.95,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M28.95,28.71c4.18-5.82,14.05-5.46,17.94,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M17,17.82c9.55-13.3,32.12-12.49,41,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.15,53.08h-4.28v2.75h3.58c0.33,0,0.58,0.07,0.74,0.22c0.16,0.15,0.25,0.35,0.25,0.6 s-0.08,0.45-0.25,0.59s-0.41,0.22-0.74,0.22h-3.58V61c0,0.45-0.1,0.78-0.3,1c-0.2,0.22-0.46,0.33-0.78,0.33 c-0.32,0-0.58-0.11-0.79-0.33s-0.3-0.55-0.3-1v-8.26c0-0.31,0.05-0.57,0.14-0.77c0.09-0.2,0.24-0.34,0.44-0.43 c0.2-0.09,0.45-0.14,0.76-0.14h5.13c0.35,0,0.6,0.08,0.77,0.23c0.17,0.15,0.25,0.36,0.25,0.6c0,0.25-0.08,0.46-0.25,0.61 C26.75,53,26.5,53.08,26.15,53.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M31.72,57.55h-0.76V61c0,0.45-0.1,0.79-0.3,1c-0.2,0.21-0.46,0.32-0.78,0.32c-0.35,0-0.62-0.11-0.81-0.34 c-0.19-0.22-0.29-0.55-0.29-0.99v-8.26c0-0.47,0.1-0.81,0.31-1.02s0.55-0.32,1.02-0.32h3.54c0.49,0,0.91,0.02,1.25,0.06 c0.35,0.04,0.66,0.13,0.94,0.25c0.34,0.14,0.63,0.34,0.89,0.61s0.46,0.57,0.59,0.92c0.13,0.35,0.2,0.72,0.2,1.11 c0,0.8-0.23,1.44-0.68,1.92c-0.45,0.48-1.14,0.82-2.05,1.02c0.39,0.21,0.75,0.51,1.11,0.91s0.67,0.83,0.94,1.28 c0.28,0.45,0.49,0.86,0.64,1.22c0.15,0.36,0.23,0.61,0.23,0.75c0,0.14-0.05,0.28-0.14,0.42c-0.09,0.14-0.21,0.25-0.37,0.33 c-0.16,0.08-0.34,0.12-0.54,0.12c-0.24,0-0.45-0.06-0.62-0.17c-0.17-0.11-0.31-0.26-0.43-0.44c-0.12-0.18-0.28-0.43-0.49-0.78 l-0.87-1.45c-0.31-0.53-0.59-0.94-0.84-1.22c-0.25-0.28-0.5-0.47-0.75-0.57S32.1,57.55,31.72,57.55z M32.96,53.03h-2.01v2.95 h1.95c0.52,0,0.96-0.04,1.32-0.14c0.36-0.09,0.63-0.24,0.82-0.46c0.19-0.22,0.28-0.52,0.28-0.9c0-0.3-0.08-0.56-0.23-0.79 c-0.15-0.23-0.36-0.4-0.63-0.51C34.21,53.09,33.71,53.03,32.96,53.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M46.66,53.08h-4.9v2.64h4.51c0.33,0,0.58,0.08,0.74,0.22c0.16,0.15,0.25,0.35,0.25,0.59 s-0.08,0.44-0.24,0.6c-0.16,0.15-0.41,0.23-0.75,0.23h-4.51v3.05h5.07c0.34,0,0.6,0.08,0.77,0.24c0.17,0.16,0.26,0.37,0.26,0.63 c0,0.25-0.09,0.46-0.26,0.62c-0.17,0.16-0.43,0.24-0.77,0.24h-5.91c-0.47,0-0.81-0.1-1.02-0.31c-0.21-0.21-0.31-0.55-0.31-1.02 v-8.07c0-0.31,0.05-0.57,0.14-0.77c0.09-0.2,0.24-0.34,0.44-0.43c0.2-0.09,0.45-0.14,0.76-0.14h5.74c0.35,0,0.6,0.08,0.77,0.23 c0.17,0.15,0.25,0.36,0.25,0.6c0,0.25-0.08,0.46-0.25,0.61C47.26,53,47,53.08,46.66,53.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M56.66,53.08h-4.9v2.64h4.51c0.33,0,0.58,0.08,0.74,0.22c0.16,0.15,0.25,0.35,0.25,0.59 s-0.08,0.44-0.24,0.6c-0.16,0.15-0.41,0.23-0.75,0.23h-4.51v3.05h5.07c0.34,0,0.6,0.08,0.77,0.24c0.17,0.16,0.26,0.37,0.26,0.63 c0,0.25-0.09,0.46-0.26,0.62c-0.17,0.16-0.43,0.24-0.77,0.24h-5.91c-0.47,0-0.81-0.1-1.02-0.31c-0.21-0.21-0.31-0.55-0.31-1.02 v-8.07c0-0.31,0.05-0.57,0.14-0.77c0.09-0.2,0.24-0.34,0.44-0.43c0.2-0.09,0.45-0.14,0.76-0.14h5.74c0.35,0,0.6,0.08,0.77,0.23 c0.17,0.15,0.25,0.36,0.25,0.6c0,0.25-0.08,0.46-0.25,0.61C57.27,53,57.01,53.08,56.66,53.08z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "lift",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17.8,53.91l-4.97-7.99c-0.5-0.81-0.26-1.88,0.55-2.38l0,0c0.81-0.5,1.88-0.26,2.38,0.55l4.97,7.99 c0.5,0.81,0.26,1.88-0.55,2.38h0C19.37,54.97,18.3,54.72,17.8,53.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M12,66.5h40.51c0.99,0,1.95-0.38,2.72-1.07c0.61-0.54,1.03-1.29,1.31-2.09L57,62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 21.72,
    y1: 45.32,
    x2: 18.5,
    y2: 47.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65,
    y1: 16,
    x2: 27.18,
    y2: 41.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 28.5,
    cy: 14.5,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.42,
    y1: 25.92,
    x2: 45.15,
    y2: 29.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.79,
    y1: 23.25,
    x2: 48,
    y2: 27.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M29.88,23.02c0.25-1.56-0.82-3.03-2.38-3.28l-1.25-0.2c-1.56-0.25-3.03,0.82-3.28,2.38l-2.95,18.7 C20,43,21.14,44.11,21.32,44.49l9.69,20.19c0.58,1.21,2.03,1.71,3.23,1.14s1.71-2.03,1.14-3.23l-9.26-19.29 c0.41-0.41,0.71-0.95,0.81-1.57l2.49-15.76"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "lift_00000042721885829184810740000001060933454269565364_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 9,
    y1: 23,
    x2: 50.5,
    y2: 8.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "65.15,67 11,67 11,52.58  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43,44l-15.48-6.38c-0.97-0.4-2.05-0.38-3,0.06L9,44.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 41,
    y1: 63,
    x2: 41,
    y2: 43.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.15,41.09L54.1,23.05c-1.71-2.8-5.37-2.72-7,0.14L37,40.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M44.12,28.44l1.98,0.45c0.59,0.13,1.12,0.48,1.53,1l1.61,2.05c1.03,1.31,2.75,1.42,3.89,0.25l1.09-1.11 c0.51-0.52,1.15-0.8,1.82-0.81l2.31-0.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M55.8,43.33l4.2,7.61l-2.02-0.76c-0.61-0.23-1.29-0.1-1.79,0.35l0,0c-0.7,0.62-1.68,0.62-2.37,0l0,0 c-0.51-0.45-1.18-0.58-1.79-0.35L50,50.94l4.2-7.61C54.57,42.67,55.43,42.67,55.8,43.33z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 43,
    className: "st15",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M51.94,51l-2.84,3.86c-0.32,0.44,0.14,0.99,0.7,0.84l2.23-0.61c0.19-0.05,0.41-0.02,0.57,0.1l1.66,1.18 c0.19,0.14,0.46,0.16,0.67,0.06l2.72-1.29c0.17-0.08,0.37-0.09,0.55-0.01l1.92,0.79c0.53,0.22,1.08-0.29,0.81-0.76L58.58,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M50.81,55.82l-3.51,4.36c-0.4,0.49,0.18,1.12,0.86,0.95l2.76-0.69c0.24-0.06,0.5-0.02,0.7,0.11l2.05,1.33 c0.24,0.15,0.56,0.18,0.83,0.06l3.35-1.45c0.21-0.09,0.46-0.1,0.68-0.01l2.37,0.9c0.66,0.25,1.33-0.32,1-0.85l-2.9-4.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 54.59,
    y1: 66.65,
    x2: 54.51,
    y2: 61.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 11,
    y1: 48.54,
    x2: 11,
    y2: 43.91
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "16,56 16,50.82 19.7,50.82 19.7,56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "24,56 24,50.82 27.7,50.82 27.7,56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "31.9,56.21 31.9,51.03 35.6,51.03 35.6,56.21  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 11,
    y1: 56.62,
    x2: 41,
    y2: 56.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "15.95,66.15 15.95,62 19.65,62 19.65,66.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "23.95,66.15 23.95,62 27.65,62 27.65,66.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "31.85,66.31 31.85,62.17 35.55,62.17 35.55,66.31  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 19.7,
    y1: 19.42,
    x2: 19.7,
    y2: 31.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 15,
    y1: 31,
    x2: 23.67,
    y2: 31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 36.11,
    y1: 13.73,
    x2: 36.11,
    y2: 25.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 31.41,
    y1: 25.31,
    x2: 40.08,
    y2: 25.31
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u043F\\u043B\\u043E\\u0449\\u0430",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M68.25,6.75v61.49H6.75V6.75H68.25 M70,5H5v65h65V5L70,5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 64.43,
    y1: 10.97,
    x2: 52.78,
    y2: 22.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "55.25,10.01 55.31,11.76 63.95,11.45 63.64,20.09 65.39,20.15 65.77,9.62  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 10.77,
    y1: 10.97,
    x2: 22.42,
    y2: 22.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "9.8,20.15 11.56,20.09 11.24,11.45 19.88,11.76 19.95,10.01 9.42,9.63  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 64.43,
    y1: 64.28,
    x2: 52.78,
    y2: 52.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "65.39,55.1 63.64,55.16 63.96,63.8 55.31,63.49 55.25,65.24 65.78,65.62  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 10.77,
    y1: 64.28,
    x2: 22.42,
    y2: 52.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "19.95,65.24 19.89,63.49 11.24,63.81 11.56,55.16 9.8,55.1 9.42,65.63  "
  })))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "guest",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 37,
    cy: 37,
    r: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M17.21,62.32c4.21-2.84,7.36-5.16,11.38-6.52c0.87-0.5,1.41-1.43,1.41-2.43v-4.55 c0-0.54-0.11-1.08-0.32-1.58c-1.08-1.56-1.85-3.47-2.4-5.6c-0.18-0.43-0.44-0.82-0.75-1.16l-0.95-1.02 c-0.58-0.63-0.91-1.45-0.91-2.3v-4.34c0-0.52,0.25-1.02,0.67-1.33h0c0.42-0.31,0.67-0.81,0.67-1.33v-5.83 c0-3.59,2.28-6.81,5.7-7.91c1.72-0.55,3.94-0.92,6.8-0.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M57.5,62.32c-4.2-2.58-7.37-4.96-11.38-6.52c-0.87-0.5-1.41-1.43-1.41-2.43v-4.55 c0-0.54,0.11-1.08,0.32-1.58c1.16-1.65,2-3.49,2.4-5.6c0.18-0.43,0.44-0.82,0.75-1.16l0.95-1.02c0.58-0.63,0.91-1.45,0.91-2.3 v-4.34c0-0.52-0.25-1.02-0.67-1.33h0c-0.42-0.31-0.67-0.81-0.67-1.33v-5.83c0-3.59-2.28-6.81-5.7-7.91 c-1.72-0.55-3.94-0.92-6.8-0.92"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "sauna",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.5,40.5c0.08,0,0.15,0.01,0.22,0.02l0.51-3.97c0.14-1.09-0.71-2.06-1.81-2.06H39.5l-0.39,6H48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.75,34.5h-0.24h-7.97c-1.09,0-1.94,0.95-1.81,2.03l0.46,3.97h9.85L19.75,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.75,62.55l0.15,1.33c0.11,0.92,0.89,1.61,1.81,1.61h6.48l-0.16-2.95H12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.81,58.45l-0.31-5.73L20.81,58.45h8.68V44.5h-9.24l0.25,5l-0.25-5h-9.59l1.62,13.97 c0.09-0.01,0.18-0.03,0.28-0.03H20.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.03,62.55 21.19,65.5 29.49,65.5 29.49,62.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.49,40.5 29.49,34.5 19.75,34.5 20.05,40.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "39.11,40.5 39.5,34.5 29.49,34.5 29.49,40.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "37.96,58.45 46.41,58.45 48.21,44.5 38.85,44.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.5,65.5h6.4c0.92,0,1.69-0.68,1.81-1.59l0.17-1.36h-8.19L37.5,65.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.49,62.55 29.49,65.5 37.5,65.5 37.69,62.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "37.96,58.45 38.85,44.5 29.49,44.5 29.49,58.45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.19,40.5H10.5c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.21,44.5h0.29c1.1,0,2-0.9,2-2c0-1.03-0.78-1.87-1.78-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.88,62.55h0.57c1.13,0,2.05-0.92,2.05-2.05c0-1.13-0.92-2.05-2.05-2.05h-0.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.22,58.48c-0.97,0.16-1.72,1-1.72,2.02c0,1.13,0.92,2.05,2.05,2.05h0.19"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M24.25,34.5c0.36-0.2,1.3-0.78,1.87-2c0.22-0.47,0.53-1.44,0-4c-0.62-3.03-1.47-3.66-1.87-6 c-0.22-1.28-0.43-2.51,0-4c0.17-0.59,0.59-1.98,1.87-3c1.22-0.97,2.55-1.06,3.3-1.03c0.75-0.03,2.09,0.06,3.32,1.03 c1.28,1.02,1.7,2.41,1.87,3c0.43,1.49,0.22,2.72,0,4c-0.4,2.34-1.24,2.97-1.87,6c-0.53,2.56-0.22,3.53,0,4 c0.56,1.22,1.5,1.8,1.87,2H24.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 29.5,
    cy: 20.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 56.5,
    cy: 18.5,
    r: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.39,22.77c3.47-6.9-1.64-15.07-9.7-15.33c8.08,0.26,12.54,8.19,9.67,15.38C64.5,27.5,59.5,31.5,59.5,36.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M59.5,36.5v27c0,1.66-1.34,3-3,3h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 59.5,
    y1: 36.5,
    x2: 59.5,
    y2: 63.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 59.5,
    y1: 36.5,
    x2: 59.5,
    y2: 63.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.61,22.77c-3.47-6.9,1.64-15.07,9.7-15.33c-8.08,0.26-12.54,8.19-9.67,15.38 C48.5,27.5,53.5,31.5,53.5,36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M53.5,36.5v27c0,1.66,1.34,3,3,3h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 53.5,
    y1: 36.5,
    x2: 53.5,
    y2: 63.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 53.5,
    y1: 36.5,
    x2: 53.5,
    y2: 63.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M55.81,7.47c0.48-0.03,0.94-0.04,1.37,0"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "double_bed",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M67.22,57H7.28c-1.67,0-3.03-1.36-3.03-3.03V48.8c0-6.52,5.28-11.8,11.8-11.8h42.39 c6.52,0,11.8,5.28,11.8,11.8v5.17C70.25,55.64,68.89,57,67.22,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M9.25,39V20.92c0-3.54,3.05-6.42,6.81-6.42h42.38c3.76,0,6.81,2.87,6.81,6.42V39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M17.42,60.5h-6.33c-0.46,0-0.83-0.37-0.83-0.83V57h8v2.67C18.25,60.13,17.88,60.5,17.42,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M33.25,37h-16v-2.04c0-2.74,2.22-4.96,4.96-4.96h6.09c2.74,0,4.96,2.22,4.96,4.96V37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M58.25,37h-16v-2.04c0-2.74,2.22-4.96,4.96-4.96h6.09c2.74,0,4.96,2.22,4.96,4.96V37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M63.42,60.5h-6.33c-0.46,0-0.83-0.37-0.83-0.83V57h8v2.67C64.25,60.13,63.88,60.5,63.42,60.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 4.75,
    y1: 51,
    x2: 70.75,
    y2: 51
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "single_bed",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M29.08,61H13.92C11.2,61,9,58.8,9,56.08V18.92C9,16.2,11.2,14,13.92,14h15.15C31.8,14,34,16.2,34,18.92v37.15 C34,58.8,31.8,61,29.08,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M15,27v-5.9c0-1.16,0.94-2.1,2.1-2.1h8.8c1.16,0,2.1,0.94,2.1,2.1V27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 9,
    y1: 27.23,
    x2: 34,
    y2: 27.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 9,
    y1: 33,
    x2: 34,
    y2: 33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M61.08,61H45.92C43.2,61,41,58.8,41,56.08V18.92C41,16.2,43.2,14,45.92,14h15.15C63.8,14,66,16.2,66,18.92 v37.15C66,58.8,63.8,61,61.08,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M47,27v-5.9c0-1.16,0.94-2.1,2.1-2.1h8.8c1.16,0,2.1,0.94,2.1,2.1V27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 41,
    y1: 27.23,
    x2: 66,
    y2: 27.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 9,
    y1: 33,
    x2: 34,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 41,
    y1: 33,
    x2: 66,
    y2: 33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.0d0679bde870c39f6da7ecc88d421d0a.svg";
export { ForwardRef as ReactComponent };